<template>
  <div class="asset-withdraw">
    <van-nav-bar title="往期资产提现" left-arrow @click-left="$router.back()" />
    <section class="balance-panel">
      <div class="eyebrow">我的资产</div>
      <div class="balance">{{ totalAsset }}</div>
      <div class="balance-caption">中国制造与中华云泊余额合计（元）</div>
    </section>

    <section class="form-panel">
      
      <van-cell
        v-if="banks.length"
        title="数字人民币钱包"
        is-link
        :value="selectedBankText"
        @click="bankPicker = true"
      />
      <van-cell v-else title="数字人民币钱包" value="暂无已审核钱包" />

      <div class="section-title amount-title">提现金额</div>
      <van-field
        v-model="amount"
        type="number"
        placeholder="请输入提现金额"
        input-align="right"
        :error-message="amountError"
      >
        <span slot="button">元</span>
      </van-field>
      <van-field
        v-model="payPassword"
        type="password"
        placeholder="请输入支付密码"
        input-align="right"
        maxlength="20"
      />
      <p class="hint">可提现时间：周一至周五早上10点-下午17点</p>
      <p class="hint">最低提现金额100元，提现金额必须按100元递增。</p>
      <van-button block type="danger" :loading="loading" :disabled="loading || !banks.length" @click="submit">
        提交提现申请
      </van-button>
    </section>

    <section class="record-panel" v-if="records.length">
      <div class="section-title">提现记录</div>
      <div v-for="item in records" :key="item.id" class="record-row">
        <div><strong>{{ item.amount }} 元</strong><span>{{ item.status_text }}</span></div>
        <small>{{ formatTime(item.created_at) }}</small>
      </div>
    </section>

    <van-action-sheet v-model="bankPicker" :actions="bankActions" cancel-text="取消" @select="selectBank" />
  </div>
</template>

<script>
import request from "@utils/request";

export default {
  name: "AssetWithdraw",
  data() {
    return { loading: false, bankPicker: false, amount: "", payPassword: "", amountError: "", totalAsset: "0.00", banks: [], selectedBank: null, records: [] };
  },
  computed: {
    bankActions() { return this.banks.map(item => ({ name: `${item.bank_name || "数字人民币"}（${String(item.account || "").slice(-4)}）`, value: item.id })); },
    selectedBankText() { return this.selectedBank ? `${this.selectedBank.bank_name || "数字人民币"}（${String(this.selectedBank.account || "").slice(-4)}）` : "请选择"; }
  },
  created() { this.load(); },
  methods: {
    async load() {
      try {
        const info = await request.get("/api/v1/user/assetWithdrawInfo", {}, { login: true });
        const payload = info && info.data !== undefined ? info.data : info;
        const data = payload && payload.data ? payload.data : payload;
        this.totalAsset = data.total_asset || "0.00";
        this.banks = data.banks || [];
        this.selectedBank = this.banks[0] || null;
        const rows = await request.get("/api/v1/user/assetWithdrawals", {}, { login: true });
        const rowPayload = rows && rows.data !== undefined ? rows.data : rows;
        this.records = rowPayload && Array.isArray(rowPayload.data) ? rowPayload.data : [];
      } catch (e) { this.$dialog.error("提现信息加载失败，请稍后重试"); }
    },
    selectBank(action) { this.selectedBank = this.banks.find(item => item.id === action.value) || this.selectedBank; this.bankPicker = false; },
    validateAmount() {
      const value = Number(this.amount);
      if (!Number.isFinite(value) || value < 100 || value % 100 !== 0) { this.amountError = "最低100元，且必须按100元递增"; return false; }
      if (value > Number(this.totalAsset)) { this.amountError = "提现金额不能超过可提现余额"; return false; }
      this.amountError = ""; return true;
    },
    //先用这个拦截，后续用下面正常的提交提交submitbak改成submit
    async submit() {
      this.$dialog.success("等待系统审核，将在30个工作日内完成款项拨付。");
    },
    //正常提交
    async submitbak() {
      if (!this.selectedBank) { this.$dialog.error("请先绑定并通过审核数字人民币钱包"); return; }
      if (!this.validateAmount()) return;
      if (!this.payPassword) { this.$dialog.error("请输入支付密码"); return; }
      this.loading = true;
      try {
        const res = await request.post("/api/v1/user/assetWithdraw", { amount: Number(this.amount), bank_id: this.selectedBank.id, pwd: this.payPassword }, { login: true });
        const payload = res && res.data !== undefined ? res.data : res;
        if (!payload || payload.code !== 200) { this.$dialog.error(payload && payload.msg ? payload.msg : "提交失败"); return; }
        this.$dialog.success(payload.msg || "提现申请已提交");
        this.amount = "";
        this.payPassword = "";
        await this.load();
      } catch (e) { const data = e && e.response && e.response.data; this.$dialog.error(data && data.msg ? data.msg : "提交失败"); }
      finally { this.loading = false; }
    },
    formatTime(value) { return value ? new Date(Number(value) * 1000).toLocaleString("zh-CN", { hour12: false }) : ""; }
  }
};
</script>

<style scoped>
.asset-withdraw { min-height: 100vh; padding-bottom: 24px; background: #f6f7f9; color: #222; }
.balance-panel { margin: 14px; padding: 22px 18px; border-radius: 12px; color: #fff; background: linear-gradient(135deg, #ff4b2b, #ef1f10); }
.eyebrow, .balance-caption { font-size: 13px; opacity: .82; }
.balance { margin: 10px 0 5px; font-size: 34px; font-weight: 700; }
.form-panel, .record-panel { margin: 0 14px 14px; padding: 4px 0 16px; border-radius: 10px; background: #fff; overflow: hidden; }
.section-title { padding: 14px 16px 8px; font-size: 16px; font-weight: 700; }
.amount-title { padding-top: 18px; }
.hint { margin: 6px 16px; color: #777; font-size: 12px; line-height: 1.5; }
.form-panel .van-button { margin: 18px 16px 0; width: calc(100% - 32px); background: #ef2b16; border-color: #ef2b16; }
.record-row { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; border-top: 1px solid #f0f1f3; }
.record-row strong { margin-right: 10px; font-size: 15px; }
.record-row span { color: #d87b00; font-size: 12px; }
.record-row small { color: #999; font-size: 11px; }
</style>
